export const formatCurrency = (amount, { showDecimals = true } = {}) => {
  const sign = Math.abs(amount) === amount ? "$" : "- $";

  const formatted = Math.abs(amount)
    .toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: showDecimals ? 2 : 0,
    })
    .slice(1);

  return `${sign} ${formatted}`;
};

export default formatCurrency;
